import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
 MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

export interface ConfirmDialogData {
  title: string;
  content: string;
  cancel?: string;
  confirm?: string;
  titleParams?: any;
  contentParams?: any;
  hideCancel?: boolean;
}

@Component({
    selector: 'fs-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);
}
